module.exports = __webpack_public_path__ + "img/source-code-pro-dark.f61d06c0.png";